import { render, staticRenderFns } from "./list-policies.vue?vue&type=template&id=30f37239&scoped=true&"
import script from "./list-policies.vue?vue&type=script&lang=js&"
export * from "./list-policies.vue?vue&type=script&lang=js&"
import style0 from "./list-policies.vue?vue&type=style&index=0&id=30f37239&prod&lang=scss&scoped=true&"
import style1 from "./list-policies.vue?vue&type=style&index=1&id=30f37239&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f37239",
  null
  
)

export default component.exports